(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[480],{

/***/ 9500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _types_dialog_interface__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3366);
/* harmony import */ var _styles_Dialog_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7940);
/* harmony import */ var _styles_Dialog_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_Dialog_module_css__WEBPACK_IMPORTED_MODULE_3__);







var styles = (_styles_Dialog_module_css__WEBPACK_IMPORTED_MODULE_3___default());
var Dialog = function(param) {
    var title = param.title, description = param.description, opened = param.opened, dismissable = param.dismissable, type = param.type, inputs = param.inputs, enableTogglingKeypresses = param.enableTogglingKeypresses, confirmButtonName = param.confirmButtonName, cancelButtonName = param.cancelButtonName, className = param.className, descriptionHTML = param.descriptionHTML, onClose = param.onClose, children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(opened), isOpen = ref[0], setIsOpen = ref[1];
    description = description || "";
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setIsOpen(opened);
        opened ? document.body.classList.add("dialog-opened") : document.body.classList.remove("dialog-opened");
        var handleKeypress = function(e) {
            if (enableTogglingKeypresses) {
                if (e.key == "Enter") {
                    handleClose(true, inputs);
                }
                if (e.key == "Escape") {
                    handleClose(false, {});
                }
                document.addEventListener("keydown", handleKeypress);
            }
        };
        if (enableTogglingKeypresses) {
            return function() {
                document.removeEventListener("keydown", handleKeypress);
            };
        }
    }, [
        opened
    ]);
    var parseMarkdownString = function(input) {
        var boldRegex = /\*\*(.*?)\*\*/g;
        var italicRegex = /\*(.*?)\*/g;
        var underlineRegex = /__(.*?)__/g;
        var result = input.replaceAll(boldRegex, "<b>$1</b>").replaceAll(italicRegex, "<em>$1</em>").replaceAll(underlineRegex, "<u>$1</u>");
        return result;
    };
    var parseMarkdown = function(input) {
        var joinedString = input.map(function(element) {
            return element.props.children;
        }).join("");
        var result = parseMarkdownString(joinedString);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            dangerouslySetInnerHTML: {
                __html: result
            }
        });
    };
    var descriptionLines = description.split("\n");
    var descriptionWithLineBreaks = descriptionLines.map(function(line, index) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: [
                parseMarkdown([
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: line
                    })
                ]),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
            ]
        }, index);
    });
    var getConfirmationButtons = function() {
        switch(type){
            case _types_dialog_interface__WEBPACK_IMPORTED_MODULE_2__/* .DialogType.INFO */ .i.INFO:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    className: styles["submit-button"],
                    onClick: function() {
                        return handleClose(true, inputs);
                    },
                    children: cancelButtonName || "ОК"
                });
            case _types_dialog_interface__WEBPACK_IMPORTED_MODULE_2__/* .DialogType.QUESTION */ .i.QUESTION:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: styles["submit-button"],
                            onClick: function() {
                                return handleClose(true, inputs);
                            },
                            children: confirmButtonName || "Да"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: styles["cancel-button"],
                            onClick: function() {
                                return handleClose(false, {});
                            },
                            children: cancelButtonName || "Нет"
                        })
                    ]
                });
            case _types_dialog_interface__WEBPACK_IMPORTED_MODULE_2__/* .DialogType.SUBMIT */ .i.SUBMIT:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    className: styles["submit-button"],
                    onClick: function() {
                        return handleClose(true, inputs);
                    },
                    children: confirmButtonName || "Отправить"
                });
            case _types_dialog_interface__WEBPACK_IMPORTED_MODULE_2__/* .DialogType.SUBMIT_WITH_CANCEL */ .i.SUBMIT_WITH_CANCEL:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: styles["submit-button"],
                            onClick: function() {
                                return handleClose(true, inputs);
                            },
                            children: confirmButtonName || "Отправить"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: styles["cancel-button"],
                            onClick: function() {
                                return handleClose(false, {});
                            },
                            children: cancelButtonName || "Отмена"
                        })
                    ]
                });
            case _types_dialog_interface__WEBPACK_IMPORTED_MODULE_2__/* .DialogType.NONE */ .i.NONE:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
        }
    };
    var handleClose = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(confirmed, inputs) {
            var ref, handlingResult, toClose;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!onClose) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            Promise.all([
                                onClose(confirmed, inputs || {})
                            ])
                        ];
                    case 1:
                        ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"].apply */ .Z.apply(void 0, [
                            _state.sent(),
                            1
                        ]), handlingResult = ref[0];
                        toClose = handlingResult == undefined ? true : handlingResult;
                        if (toClose || !confirmed) {
                            setIsOpen(false);
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        setIsOpen(false);
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClose(confirmed, inputs) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: isOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "".concat(styles.dialog).concat(className ? " " + className : ""),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: styles.content,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: styles["dialog-info"],
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: title
                                }),
                                description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: descriptionHTML ? "" : descriptionWithLineBreaks
                                }) : descriptionHTML ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    dangerouslySetInnerHTML: {
                                        __html: descriptionHTML
                                    }
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                            ]
                        }),
                        children,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: styles.actions,
                            children: getConfirmationButtons()
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: styles.overlay,
                    onClick: dismissable ? function() {
                        return handleClose(false, {});
                    } : undefined
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Dialog);


/***/ }),

/***/ 487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lib_misc_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1761);
/* harmony import */ var _styles_Footer_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3882);
/* harmony import */ var _styles_Footer_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_Footer_module_css__WEBPACK_IMPORTED_MODULE_3__);




var styles = (_styles_Footer_module_css__WEBPACK_IMPORTED_MODULE_3___default());
var footerColumns = [
    {
        title: "О нас",
        text: _lib_misc_constants__WEBPACK_IMPORTED_MODULE_2__/* .APP_DESCRIPTION */ .PB
    },
    {
        title: "Контакты",
        links: [
            {
                name: "Электронная почта",
                href: "mailto:contact@schooltester.com"
            }
        ]
    },
    {
        title: "Сервисы",
        links: [
            {
                name: "Создать тест",
                href: "/tests/create"
            },
            {
                name: "Ваши тесты",
                href: "/tests/created"
            },
            {
                name: "Библиотека тестов",
                href: "/tests/library"
            }
        ]
    }
];
var Footer = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("footer", {
        className: styles.footer,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: styles.container,
                children: footerColumns.map(function(footerColumn, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: styles.column,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                children: footerColumn.title
                            }),
                            footerColumn.text ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: footerColumn.text
                            }) : null,
                            footerColumn.links ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                children: footerColumn.links.map(function(link, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            href: link.href,
                                            children: link.className ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                className: link.className,
                                                children: link.name
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                children: link.name
                                            })
                                        })
                                    }, index);
                                })
                            }) : null
                        ]
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: styles.bottom,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        children: [
                            "\xa9 ",
                            new Date().getFullYear(),
                            " ",
                            _lib_misc_constants__WEBPACK_IMPORTED_MODULE_2__/* .APP_NAME */ .iC
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: "Все права защищены."
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Footer);


/***/ }),

/***/ 769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Navbar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(2670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(414);
;// CONCATENATED MODULE: ./src/utils/handleError.util.ts



/**
 * Executes the callback function with handling all the errors.
 * @param callback Callback function to execute.
 * @returns Callback function execution result.
 */ var handleError = function(callback) {
    try {
        var result = callback();
        if ((0,_instanceof/* default */.Z)(result, Promise)) {
            var awaitResult = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function() {
                    var awaitedResult, err;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    result
                                ];
                            case 1:
                                awaitedResult = _state.sent();
                                return [
                                    2,
                                    {
                                        error: null,
                                        result: awaitedResult
                                    }
                                ];
                            case 2:
                                err = _state.sent();
                                return [
                                    2,
                                    {
                                        error: err,
                                        result: null
                                    }
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function awaitResult() {
                    return _ref.apply(this, arguments);
                };
            }();
            return awaitResult();
        }
        return {
            error: null,
            result: result
        };
    } catch (err) {
        return {
            error: err,
            result: null
        };
    }
};

// EXTERNAL MODULE: ./src/lib/misc/constants.ts
var constants = __webpack_require__(1761);
// EXTERNAL MODULE: ./src/styles/Navbar.module.css
var Navbar_module = __webpack_require__(4087);
var Navbar_module_default = /*#__PURE__*/__webpack_require__.n(Navbar_module);
;// CONCATENATED MODULE: ./src/components/Navbar.tsx







var styles = (Navbar_module_default());
var Navbar = function() {
    var ref = (0,react.useState)(false), showMenu = ref[0], setShowMenu = ref[1];
    var handleMenuToggle = function() {
        setShowMenu(!showMenu);
    };
    var hideMenu = function() {
        setShowMenu(false);
    };
    var ref1 = (0,react.useState)([]), links = ref1[0], setLinks = ref1[1];
    (0,react.useEffect)(function() {
        var accessToken = localStorage.getItem("accessToken");
        var rawUser = handleError(function() {
            return JSON.parse(localStorage.getItem("user"));
        });
        var user = rawUser.result || {};
        if (accessToken) {
            setLinks([
                {
                    name: user.username,
                    href: "#",
                    icon: "fas fa-user",
                    style: {
                        cursor: "default"
                    }
                },
                {
                    name: "Библиотека",
                    icon: "fas fa-book",
                    href: "/tests/library"
                },
                {
                    name: "Настройки аккаунта",
                    icon: "fas fa-shield-alt",
                    href: "/account"
                },
                {
                    name: "Ваши тесты",
                    icon: "fas fa-cog",
                    href: "/tests/created"
                },
                {
                    name: "Выход",
                    icon: "fas fa-door-open",
                    href: "/logout",
                    className: styles["logout-button"]
                }
            ]);
        } else {
            setLinks([
                {
                    name: "Библиотека",
                    icon: "fas fa-book",
                    href: "/tests/library"
                },
                {
                    name: "Вход",
                    icon: "fas fa-sign-in-alt",
                    href: "/login"
                },
                {
                    name: "Регистрация",
                    icon: "fas fa-user-plus",
                    href: "/register"
                }
            ]);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
            className: styles.nav,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: styles.logo,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/tester.svg",
                                alt: "logo",
                                height: 30,
                                width: 30
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: styles["app-name"],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/",
                        children: constants/* APP_NAME */.iC
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: styles["menu-toggle"],
                    onClick: handleMenuToggle,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: showMenu ? "fas fa-times" : "fas fa-bars"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat(styles["nav-links"], " ").concat(showMenu ? styles.active : ""),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        onClick: hideMenu,
                        children: links.map(function(link, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: link.href,
                                    children: link.className ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: link.className,
                                        style: link.style,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: link.icon
                                            }),
                                            link.name
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        style: link.style,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: link.icon
                                            }),
                                            link.name
                                        ]
                                    })
                                })
                            }, index);
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_Navbar = (Navbar);


/***/ }),

/***/ 3366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ DialogType; }
/* harmony export */ });
var DialogType;
(function(DialogType) {
    DialogType[DialogType["INFO"] = 0] = "INFO";
    DialogType[DialogType["QUESTION"] = 1] = "QUESTION";
    DialogType[DialogType["SUBMIT"] = 2] = "SUBMIT";
    DialogType[DialogType["SUBMIT_WITH_CANCEL"] = 3] = "SUBMIT_WITH_CANCEL";
    DialogType[DialogType["NONE"] = 4] = "NONE";
})(DialogType || (DialogType = {}));


/***/ }),

/***/ 7940:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dialog":"Dialog_dialog__THu6o","content":"Dialog_content__t2syO","dialog-info":"Dialog_dialog-info__j1_UR","actions":"Dialog_actions__xMAgR","overlay":"Dialog_overlay__Hu_IV","submit-button":"Dialog_submit-button__SVCAU","processing":"Dialog_processing__YZfAM","cancel-button":"Dialog_cancel-button__d8uJf","dialog-close":"Dialog_dialog-close__mHTeh"};

/***/ }),

/***/ 3882:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__pJUho","container":"Footer_container__z46Qy","column":"Footer_column__V2CwQ","bottom":"Footer_bottom__WPI3G"};

/***/ }),

/***/ 4087:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"app-name":"Navbar_app-name__LqqBn","nav":"Navbar_nav__FD0Ny","logo":"Navbar_logo__8xjov","nav-links":"Navbar_nav-links__X4a2i","menu-toggle":"Navbar_menu-toggle__l19zu","footer":"Navbar_footer__f2EX3","logout-button":"Navbar_logout-button__e9VIT","active":"Navbar_active__dvQhm"};

/***/ })

}]);